import { Button } from '@ps-design-system/components/Button';
import CalendarIcon from '@ps-design-system/icons/Calendar/Calendar24';
import GroupIcon from '@ps-design-system/icons/Group/Group24';
import MapPinIcon from '@ps-design-system/icons/MapPin/MapPin24';
import TimeIcon from '@ps-design-system/icons/Time/Time24';
import React, { useState } from 'react';
import { MobileTray } from '../../shared-components/trays/mobile-tray';
import { withBookingDetails } from './with-booking-details';

export const CateringBookingDetailsTray = withBookingDetails(
  ({ displayDate, displayTime, displayLocation, displayAttendees }) => {
    const [showTray, setShowTray] = useState(false);

    return (
      <>
        <Button fullWidth={true} onClick={() => setShowTray(true)}>
          About you booking
        </Button>

        <MobileTray
          className="catering-booking-tray"
          title="About your booking"
          isVisible={showTray}
          setIsVisible={setShowTray}
          backgroundOverlay={true}
          useHeaderBorder={false}
        >
          <div className="catering-booking-tray-body">
            <div className="catering-booking-detail-item">
              <CalendarIcon style={{ minWidth: '24px' }} />
              <span className="tw-body-2">{displayDate}</span>
            </div>
            <div className="catering-booking-detail-item">
              <TimeIcon style={{ minWidth: '24px' }} />
              <span className="tw-body-2">{displayTime}</span>
            </div>
            <div className="catering-booking-detail-item">
              <MapPinIcon style={{ minWidth: '24px' }} />
              <span className="tw-body-2">{displayLocation}</span>
            </div>
            <div className="catering-booking-detail-item">
              <GroupIcon style={{ minWidth: '24px' }} />
              <span className="tw-body-2">{displayAttendees}</span>
            </div>
          </div>
        </MobileTray>
      </>
    );
  }
);
